import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from "@angular/forms";
import { UserService } from "src/app/shared/user/user.service";
import { User } from "../../shared/user/user.model";
import { AnalyticsService } from "src/app/shared/analytics/analytics.service";

type UpgradeDescriptionFormModel = FormGroup<{
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  company: FormControl<string>;
  email: FormControl<string>;
  service: FormControl<string>;
}>;

@Component({
  selector: "app-upgrade",
  templateUrl: "./upgrade.component.html",
  styleUrls: ["./upgrade.component.scss"],
})
export class UpgradeComponent implements OnInit {
  upgradeSubscriptionForm: UpgradeDescriptionFormModel;
  user: User = this.userService.getUser();
  company: string;
  service: string;
  errorMessage = "";

  constructor(
    private location: Location,
    private formBuilder: FormBuilder,
    private userService: UserService,
    public analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.upgradeSubscriptionForm = this.formBuilder.group({
      firstName: [this.user.firstName, [Validators.required]],
      lastName: [this.user.lastName, [Validators.required]],
      company: ["", [Validators.required]],
      email: [this.user.emailAddress, [Validators.required, Validators.email]],
      service: "Spectrum Database - Demo mode",
    });
  }

  resetForm() {
    this.upgradeSubscriptionForm.setValue({
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      service: "Spectrum Database - Demo mode",
    });
  }

  onSubmit(e: any) {
    if (this.upgradeSubscriptionForm.invalid) {
      console.log("error in form :  check the fields");
      this.errorMessage = "<h3><b>Mandatory fields</b> are not filled.</>";
      return;
    } else {
      console.log("Form submitted successfully");
      this.errorMessage = "";
      this.analyticsService.pushUpgradeFormClickEvent();
      e.target.submit();
    }
  }

  goBack() {
    this.location.back();
  }
}
